export class ProductListController {
  constructor({ onAfterRender, toast }) {
    this.onAfterRender = onAfterRender;
    this.toast = toast;

    this.productsRoot = document.querySelector(".js-products-root");
    this.filtersForm = document.querySelector(".js-products-filters");
    this.productsResults = document.querySelector(".js-products-results");

    this.init();
  }

  init() {
    if (!this.productsRoot || !this.filtersForm || !this.productsResults) return;

    this.filtersForm.addEventListener("submit", (e) => {
      e.preventDefault();
      this.loadFromForm();
    });

    // Keep reset working after AJAX partial updates by delegating click on form root.
    this.filtersForm.addEventListener("click", (e) => {
      const target = e.target instanceof Element ? e.target.closest(".products-filters__reset") : null;
      if (!target) return;
      e.preventDefault();
      this.clearFiltersForm();
      this.loadFromForm();
    });

    this.bindPagination();
  }

  clearFiltersForm() {
    const controls = this.filtersForm.querySelectorAll("input, select, textarea");
    controls.forEach((control) => {
      if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement || control instanceof HTMLTextAreaElement)) return;
      if (control.disabled) return;

      if (control instanceof HTMLInputElement) {
        const type = (control.type || "").toLowerCase();
        if (type === "checkbox" || type === "radio") {
          control.checked = false;
          return;
        }
      }

      if (control instanceof HTMLSelectElement) {
        control.selectedIndex = 0;
        return;
      }

      control.value = "";
    });
  }

  bindPagination() {
    this.productsResults.querySelectorAll(".pagination a").forEach((link) => {
      if (link.dataset.boundPaging === "1") return;
      link.dataset.boundPaging = "1";
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const href = link.getAttribute("href") || "";
        const page = new URL(href, window.location.origin).searchParams.get("page") || "1";
        this.loadFromForm({ page });
      });
    });
  }

  loadFromForm(extraParams = {}) {
    const action = this.productsRoot.dataset.listUrl || window.location.pathname;
    const formData = new FormData(this.filtersForm);
    const params = new URLSearchParams();

    formData.forEach((value, key) => {
      const normalized = String(value || "").trim();
      if (!normalized) return;
      params.set(key, normalized);
    });

    Object.entries(extraParams).forEach(([key, value]) => {
      if (value === null || value === undefined || `${value}`.trim() === "") return;
      params.set(key, `${value}`);
    });

    const query = params.toString();
    const targetUrl = query ? `${action}?${query}` : action;
    this.loadFromUrl(targetUrl);
  }

  async loadFromUrl(url) {
    this.productsRoot.classList.add("is-loading");

    try {
      const res = await fetch(url, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!res.ok) throw new Error("list_fetch_failed");

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const newResults = doc.querySelector(".js-products-results");
      const newFilters = doc.querySelector(".js-products-filters");

      if (!newResults || !newFilters) throw new Error("list_parse_failed");

      this.productsResults.innerHTML = newResults.innerHTML;
      this.filtersForm.innerHTML = newFilters.innerHTML;

      const nextUrl = new URL(url, window.location.origin);
      window.history.replaceState({}, "", `${nextUrl.pathname}${nextUrl.search}`);

      this.bindPagination();
      if (typeof this.onAfterRender === "function") {
        this.onAfterRender();
      }

      if (window.lucide?.createIcons) {
        window.lucide.createIcons();
      }
    } catch {
      this.toast("Liste güncellenemedi. Sayfa yenileniyor.", "error");
      window.location.href = url;
    } finally {
      this.productsRoot.classList.remove("is-loading");
    }
  }
}
